(function () {
    'use strict';
    huffpostReady.cb = [];

    window.huffpostReady = huffpostReady;

    function huffpostReady(callback) {
        huffpostReady.cb.push(callback);
    }
}) ();